import { isProdEnv } from '../../../build-scripts/environment';

export enum ClubRedesignBuildState {
  PROD,
  TEST,
}

export enum ClubPageType {
  OLD,
  NEW,
  ALL,
}

export const shouldUseClubRedesign = (clubRedesignBuildState: ClubRedesignBuildState) =>
  clubRedesignBuildState === ClubRedesignBuildState.PROD ||
  (clubRedesignBuildState === ClubRedesignBuildState.TEST && !isProdEnv);
